module.exports = __webpack_public_path__ + "img/fm-p2@2x.0ccc5840.png";